/* global __dirname */
import React from 'react';
import fs from 'fs';
import { reportHeader, reportHeaderTitle, logoStyle } from './styles.css';

// The logo is inlined as a data URI (Parcel 1 resolves fs.readFileSync at
// build time). Importing it as a regular asset breaks: this component is
// only used by lazy-loaded pages, so Parcel 1 hoists it to the main bundle
// but leaves the image module behind in the first chunk that imported it,
// causing "Cannot find module '../components/print-header/<image>'".
// eslint-disable-next-line no-sync
const logo = `data:image/svg+xml;base64,${fs.readFileSync(
  `${__dirname}/../../static/newLogoAngellira.svg`,
  'base64',
)}`;

export default function PrintHeader() {
  return <div className={reportHeader}>
    <div>
      <span className={reportHeaderTitle}>Detalhes da consulta</span>
      <img
        style={{ maxHeight: '50px' }}
        src={logo}
        className={logoStyle}
        alt="AngelLira Logo"
      />
    </div>
    <hr style={{marginTop: 0}} />
  </div>;
}
